/**
 * One-time cleanup of localStorage keys left behind by the Company → Client
 * rename (July 2026). Runs before React mounts so ClientContext sees the
 * migrated value on its first read. Safe to keep long-term: it's a no-op
 * once the legacy keys are gone.
 */
export function migrateLegacyLocalStorage(): void {
  const legacySelected = localStorage.getItem('selectedCompany');
  if (legacySelected !== null) {
    if (localStorage.getItem('selectedClient') === null) {
      localStorage.setItem('selectedClient', legacySelected);
    }
    localStorage.removeItem('selectedCompany');
  }

  // vct:recent-dropdown:<user>:companies → vct:recent-dropdown:<user>:clients
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (!key || !key.startsWith('vct:recent-dropdown:') || !key.endsWith(':companies')) continue;
    const newKey = key.slice(0, -':companies'.length) + ':clients';
    const value = localStorage.getItem(key);
    if (value !== null && localStorage.getItem(newKey) === null) {
      localStorage.setItem(newKey, value);
    }
    localStorage.removeItem(key);
  }
}
